var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#C6C7CA"},React.createElement("g",null,React.createElement("path",{"d":"M197.441 25.059c.745.745.745 1.952 0 2.697l-6.743 6.744 6.743 6.744c.745.745.745 1.952 0 2.697-.745.745-1.952.745-2.697 0L188 37.198l-6.744 6.743c-.745.745-1.952.745-2.697 0-.745-.745-.745-1.952 0-2.697l6.743-6.744-6.743-6.744c-.745-.745-.745-1.952 0-2.697.745-.745 1.952-.745 2.697 0L188 31.802l6.744-6.743c.745-.745 1.952-.745 2.697 0z","transform":"translate(-178 -544) translate(0 520)"})))));
}

Close.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21"};

module.exports = Close;

Close.default = Close;
